import React from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

import { getPaginationLink } from '../utils'
import ResultRow from './ResultRow'

import type { TitleType } from '@models/Title'

interface Props {
  titles: TitleType[]
  startPage: number
}
const ListResults: React.FC<Props> = ({ titles, startPage }: Props) => {
  const { t } = useTranslation()
  const session = useSession()
  const { pathname } = useLocation()

  const showPriceColumn = session.isDefaultCommunity() && !isLearnPcPreview(pathname)

  return (
    <>
      <div className="flex flex-row px-2.5 text-black dark:text-gray">
        <span className="w-[30px]" />
        <p className="flex-1 px-1.5 pb-3 pt-1 font-medium text-md basis-1/4 ellipsify">
          {t('content.title')}
        </p>
        <p className="font-medium text-md pb-3 pt-1 px-1.5 flex-1 basis-[12%] ellipsify">
          {t('content.artistWriter')}
        </p>
        <p className="font-medium text-md pb-3 pt-1 px-1.5 flex-1 basis-[5%] ellipsify">
          {t('content.format')}
        </p>
        <p className="font-medium text-md pb-3 pt-1 px-1.5 flex-1 basis-[5%] ellipsify">
          {t('content.genre')}
        </p>
        {showPriceColumn && (
          <p className="font-medium text-md pb-3 pt-1 px-1.5 flex-1 basis-[3%]">
            {t('content.price')}
          </p>
        )}
      </div>
      {titles.map((title, index) => (
        <ResultRow
          title={title}
          key={title.uuid}
          showPriceColumn={showPriceColumn}
          paginationNumLink={getPaginationLink(index, startPage)}
        />
      ))}
    </>
  )
}

export default ListResults
